import imageCompression from 'browser-image-compression'

const COMPRESSIBLE_IMAGE_TYPES = new Set(['image/jpeg', 'image/jpg', 'image/png', 'image/webp'])

function replaceExtension(fileName: string, extension: string) {
  const extensionIndex = fileName.lastIndexOf('.')
  const baseName = extensionIndex > 0 ? fileName.slice(0, extensionIndex) : fileName
  return `${baseName}.${extension}`
}

export function canCompressImage(file: File) {
  return COMPRESSIBLE_IMAGE_TYPES.has(file.type)
}

export async function compressImageForUpload(file: File) {
  if (!canCompressImage(file)) {
    return { file, compressed: false }
  }

  const compressed = await imageCompression(file, {
    maxSizeMB: 2,
    maxWidthOrHeight: 2560,
    initialQuality: 0.82,
    fileType: 'image/webp',
    useWebWorker: true,
  })

  if (compressed.size >= file.size) {
    return { file, compressed: false }
  }

  return {
    file: new File([compressed], replaceExtension(file.name, 'webp'), {
      lastModified: file.lastModified,
      type: 'image/webp',
    }),
    compressed: true,
  }
}
